import { OfferNetworkProvider } from "@redotech/redo-integrations-definitions-common/offer-network/offer-placement";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const disconnectOfferNetwork = {
  name: "disconnectOfferNetwork" as const,
  input: z.object({
    provider: createEnum(Object.values(OfferNetworkProvider)),
  }),
  output: z.object({ success: z.boolean() }),
};
